export default __webpack_public_path__ + "static/media/projector.7d1a4c55.png";